import Home from './pages/Home';
import About from './pages/About';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import CelebrationsPage from './pages/CelebrationsPage';
import FoodPage from './pages/FoodPage';
import BookNow from './pages/BookNow';
import RefundPolicy from './pages/RefundPolicy';
import Admin from './pages/Admin';
import AdminDashboard from './pages/AdminDashboard';
import ChangeMetadata from './pages/ChangeMetadata';
import AdminSiteContent from './pages/AdminSiteContent';
import AdminSiteImages from './pages/AdminSiteImages';
import AdminTheatreGallery from './pages/AdminTheatreGallery';
import AdminPromoCodes from './pages/AdminPromoCodes';
import AdminCustomerLeads from './pages/AdminCustomerLeads';
import EventDetails from './pages/EventDetails';
import MyBooking from './pages/MyBooking';
import QuickBookPage from './pages/QuickBookPage';
import AdminMarketing from './pages/AdminMarketing';
import AdminBookingAnalytics from './pages/AdminBookingAnalytics';
import AdminBanquetHall from './pages/AdminBanquetHall';
import AdminPaymentFailed from './pages/AdminPaymentFailed';
import AdminPartyBossSlotBookingFlow from './pages/AdminPartyBossSlotBookingFlow';

import TnC from './pages/TnC';
import Privacy from './pages/PrivacyPolicy';
import Addons from './pages/AddOns';
import PageNotFound from "./pages/PageNotFound";

const routes = [
  { path: '/', component: <Home />, exact: true },
  { path: '/Home', component: <Home />, exact: true },
  { path: '/about', component: <About /> },
  { path: '/celebrations', component: <CelebrationsPage /> },
  { path: '/food', component: <FoodPage /> },
  { path: '/gallery', component: <Gallery /> },
  { path: '/refundpolicy', component: <RefundPolicy /> },
  { path: '/contact', component: <Contact /> },
  { path: '/my-booking', component: <MyBooking /> },
  { path: '/quick-book', component: <QuickBookPage /> },
  { path: '/booknow/*', component: <BookNow /> },
  { path: '/admin', component: <Admin /> },
  { path: '/privacy-policy', component: <Privacy /> },
  { path: '/admin/dashboard', component: <AdminDashboard />},
  { path: '/admin/partyboss-slot-booking/*', component: <AdminPartyBossSlotBookingFlow />},
  { path: '/admin/changedata', component: <ChangeMetadata />},
  { path: '/admin/site-content', component: <AdminSiteContent />},
  { path: '/admin/page-images', component: <AdminSiteImages />},
  { path: '/admin/theatre-gallery', component: <AdminTheatreGallery />},
  { path: '/admin/promo-codes', component: <AdminPromoCodes />},
  { path: '/admin/customer-leads', component: <AdminCustomerLeads />},
  { path: '/admin/marketing', component: <AdminMarketing />},
  { path: '/admin/booking-analytics', component: <AdminBookingAnalytics />},
  { path: '/admin/banquet-hall', component: <AdminBanquetHall />},
  { path: '/admin/payment-failed', component: <AdminPaymentFailed />},
  { path: '/tnc', component: <TnC />},
  { path: '/addons', component: <Addons />},
  {path:'/event-details', component: <EventDetails />},
  {path:'/error', component: <PageNotFound />}
];

export default routes;